import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../../../components/tables/tableContext/TableContext";
import { BinsFromVolumeDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import { getDateAndTime } from "../../../../../../utils/dateAndTime";
import { getBinsStatusLabel } from "../../../components/tableConfigs/binsVolumeTableConfig";

export const showBinsFromVolumeTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. BIN",
    value: "sn_bin",
    minW: 125,
  },
  {
    label: "Client",
    value: "client",
    minW: 125,
  },
  {
    label: "Adresa ridicare",
    value: "adresa_ridicare",
    minW: 125,
  },
  {
    label: "Punct ridicare",
    value: "punct_ridicare",
    minW: 125,
  },
  {
    label: "Nod preluare",
    value: "nod_preluare",
    minW: 125,
  },

  {
    label: "Nod destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Data crearii",
    value: "data_operatie",
    minW: 125,
  },
  {
    label: "Total colete scanate",
    value: "total_colete",
    minW: 125,
  },
];

export const getShowBinsFromVolumesTableData = (
  data: BinsFromVolumeDataInterface[],
): TableData[] =>
  data.map((item) => {
    const packagesWithProblems = item.withProblems;

    const getTitleColor = () => {
      if (packagesWithProblems) {
        return "red";
      }
      return "black";
    };

    const getNrBinTitle = () => {
      if (packagesWithProblems) {
        if (item.withProblems === "wrongNode") {
          return "Colete ajunse in nodul gresit: " + item.sn_bin;
        }
        return "Colete nescanate: " + item.sn_bin;
      }
      return item.sn_bin;
    };

    return {
      id: item.id_bin ? item.id_bin : item.id_bin + item.sn_bin,
      crudData: item,
      data: [
        {
          title: getNrBinTitle(),
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.client,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.adresa_ridicare,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.punct_ridicare,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.nod_preluare,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          title: item.nod_destinatie,
          titleStyle: {
            color: getTitleColor(),
          },
        },
        {
          badges: [
            {
              badgeText: getBinsStatusLabel(item.status),
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.data_operatie
                ? getDateAndTime(item.data_operatie)
                : "-",
              badgeColor: item.withProblems ? "light-danger" : "light-info",
            },
          ],
        },
        {
          badges: [
            {
              badgeText: item.total_colete_scanate
                ? item.total_colete_scanate
                : "-",

              badgeColor: item.withProblems ? "light-danger" : "success",
            },
          ],
        },
      ],
    };
  });
